import audiImg from "./assets/carBrands/logo/audi.svg"
import bmwImg from "./assets/carBrands/logo/bmw.svg"
import mercedesImg from "./assets/carBrands/logo/mercedes.svg"
import porscheImg from "./assets/carBrands/logo/porsche.svg"
import seatImg from "./assets/carBrands/logo/seat.svg"
import skodaImg from "./assets/carBrands/logo/skoda.svg"
import vwImg from "./assets/carBrands/logo/volkswagen.svg"
import alphaRomeoImg from "./assets/carBrands/logo/alfa_romeo.svg"
import citroenImg from "./assets/carBrands/logo/citroen.svg"
import daciaImg from "./assets/carBrands/logo/dacia.svg"
import fiatImg from "./assets/carBrands/logo/fiat.svg"
import fordImg from "./assets/carBrands/logo/ford.svg"
import hondaImg from "./assets/carBrands/logo/honda.svg"
import hyundaiImg from "./assets/carBrands/logo/hyundai.svg"
import jaguarImg from "./assets/carBrands/logo/jaguar.svg"
import jeepImg from "./assets/carBrands/logo/jeep.svg"
import kiaImg from "./assets/carBrands/logo/kia.svg"
import landRoverImg from "./assets/carBrands/logo/land_rover.svg"
import mazdaImg from "./assets/carBrands/logo/mazda.svg"
import miniImg from "./assets/carBrands/logo/mini.svg"
import mitsubishiImg from "./assets/carBrands/logo/mitsubishi.svg"
import nissanImg from "./assets/carBrands/logo/nissan.svg"
import opelImg from "./assets/carBrands/logo/opel.svg"
import peugeotImg from "./assets/carBrands/logo/peugeot.svg"
import renaultImg from "./assets/carBrands/logo/renault.svg"
import subaruImg from "./assets/carBrands/logo/subaru.svg"
import suzukiImg from "./assets/carBrands/logo/suzuki.svg"
import toyotaImg from "./assets/carBrands/logo/toyota.svg"
import volvoImg from "./assets/carBrands/logo/volvo.svg"

const brands = [
  { label: "Alpha Romeo", value: "alfa_romeo", img: alphaRomeoImg },
  { label: "Audi", value: "audi", img: audiImg },
  { label: "BMW", value: "bmw", img: bmwImg },
  { label: "Citroen", value: "citroen", img: citroenImg },
  { label: "Dacia", value: "dacia", img: daciaImg },
  { label: "Fiat", value: "fiat", img: fiatImg },
  { label: "Ford", value: "ford", img: fordImg },
  { label: "Honda", value: "honda", img: hondaImg },
  { label: "Hyundai", value: "hyundai", img: hyundaiImg },
  { label: "Jaguar", value: "jaguar", img: jaguarImg },
  { label: "Jeep", value: "jeep", img: jeepImg },
  { label: "Kia", value: "kia", img: kiaImg },
  { label: "Land Rover", value: "land_rover", img: landRoverImg },
  { label: "Mazda", value: "mazda", img: mazdaImg },
  { label: "Mercedes", value: "mercedes", img: mercedesImg },
  { label: "Mini", value: "mini", img: miniImg },
  { label: "Mitsubishi", value: "mitsubishi", img: mitsubishiImg },
  { label: "Nissan", value: "nissan", img: nissanImg },
  { label: "Opel", value: "opel", img: opelImg },
  { label: "Peugeot", value: "peugeot", img: peugeotImg },
  { label: "Porsche", value: "porsche", img: porscheImg },
  { label: "Renault", value: "renault", img: renaultImg },
  { label: "Seat", value: "seat", img: seatImg },
  { label: "Skoda", value: "skoda", img: skodaImg },
  { label: "Subaru", value: "subaru", img: subaruImg },
  { label: "Suzuki", value: "suzuki", img: suzukiImg },
  { label: "Toyota", value: "toyota", img: toyotaImg },
  { label: "Volkswagen", value: "volkswagen", img: vwImg },
  { label: "Volvo", value: "volvo", img: volvoImg },
]

export default brands
